import { useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useAction } from 'utils/actions'
import { useEventListener } from 'utils/hooks'
import * as T from 'api/constants'

const PAGES = [
  {
    path: '/',
    interactions: ['#greeting-location', '#vote-wishlist'],
  },
  {
    path: '/wallet',
    interactions: [
      '#see-how', 
      '#show-savings-details', 
      '#connect-an-account', 
      // '#change-amount', 
      // '#select-recurring-contribution-account', 
      '#disconnect-payroll', 
      '#one-time-boost', 
      '#create-new-budget',
    ],
  },
  // {
  //   path: '/explore',
  //   interactions: [
  //     '#travel-designer',
  //     '.slider__nav--right',
  //     '.slider__nav--right',
  //   ]
  // },
  {
    // path: '/trip-planning/my-trips/budget/:id',
    preload: {
      type: T.GET_ALL_TRIPS,
      selector: 'allTrips',
      cb: (data, navigate) => navigate(`/trip-planning/my-trips/budget/${data?.[0]?.unique_id}`),
    },
  },
  {
    path: '/trip-planning/my-trips/budgets',
  },
  {
    path: '/trip-planning/my-trips',
  },
  {
    // path: '/trip-planning/my-trips/:id',
    preload: {
      type: T.GET_ALL_TRIPS,
      selector: 'allTrips',
      cb: (data, navigate) => navigate(`/trip-planning/my-trips/${data?.[0]?.unique_id}`),
    },
  },
  {
    path: '/my-account',
  },
  // {
  //   path: '/company',
  // },
  {
    path: '/admin/account-details',
  },
  {
    path: '/admin/user-management',
  },
  {
    path: '/admin/budgeting',
  },
  {
    path: '/admin/statements',
  },
  // {
  //   path: '/admin/hris-connection',
  // },
  {
    path: '/advanced-stats',
  },
  {
    path: '/my-team',
  },
  {
    path: '/faq/user',
  },
  {
    path: '/faq/manager',
  },
  {
    path: '/faq/admin',
  },
  {
    path: '/budgets',
  },
  {
    // path: '/budget/:id',
    preload: {
      type: T.GET_ALL_BUDGETS,
      selector: 'budgets',
      cb: (data, navigate) => navigate(`/budget/${data?.[0]?.unique_id}`),
    },
  },
  {
    // path: '/budget-settings/:id',
    preload: {
      type: T.GET_ALL_BUDGETS,
      selector: 'budgets',
      cb: (data, navigate) => navigate(`/budget-settings/${data?.[0]?.unique_id}`),
    },
  },
  // {
  //   // path: '/destinations/:id',
  //   preload: {
  //     type: T.GET_RANDOM_DESTINATIONS,
  //     selector: 'randomDestinations',
  //     cb: (data, navigate) => navigate(`/destinations/${data?.[0]?.id}`),
  //   },
  // },
  {
    path: '/statements/user',
  },
  // {
  //   path: '/statements/:category/:id?',
  // },
  {
    // path: '/experiences/vendor/:id',
    preload: {
      type: T.GET_FEATURED_VENDORS,
      selector: 'featuredVendors',
      cb: (data, navigate) => navigate(`/experiences/vendor/${data?.[0]?.id}`),
    },
  },
  // {
  //   path: '/experiences/things-to-do?location_id',
  // },
  // {
  //   path: '/experiences/guided-tours/:id/:location_id?',
  // },
  // {
  //   path: '/experiences/:id',
  // },
  // {
  //   path: '/experience/things-to-do/:id',
  // },
  // {
  //   path: '/experience/:id',
  // },
  // {
  //   path: '/tour/:cityID/:tourID/:book?',
  // },
  {
    path: '/upload-log',
  },
  {
    path: '/reward-log',
  },
  {
    path: '/employee-sync-status',
  },
  {
    path: '/donde-top-fives',
  },
  {
    path: '/trip-planning/my-collections',
  },
  {
    path: '/trip-planning/my-collections/favorites',
  },
  {
    path: '/shop-travel/stays/hotels',
  },
  // {
  //   path: '/shop-travel/stays/hotel/:id/:bundleID?',
  // },
  // {
  //   path: '/travel-companion/:id',
  // },
  {
    path: '/onboarding/welcome',
  },
  {
    path: '/onboarding/savings-account-consent',
  },
  {
    path: '/onboarding/general-info',
  },
  {
    path: '/onboarding/personal-identification',
  },
  {
    path: '/onboarding/savings-account-ready',
  },
  {
    path: '/onboarding/start-investing',
  },
  {
    path: '/onboarding/plaid',
  },
  {
    path: '/onboarding/authorization',
  },
  {
    path: '/onboarding/schedule-automatic-deposit',
  },
  {
    path: '/onboarding/linked-and-scheduled',
  },
  {
    path: '/onboarding/account-connected',
  },
  {
    path: '/onboarding/information-being-reviewed',
  },
  {
    path: '/onboarding/information-being-reviewed-create-account',
  },
  {
    path: '/onboarding/fix-issue',
  },
  {
    path: '/onboarding/refill-information',
  },
  {
    path: '/onboarding/identity-not-verified',
  },
  {
    path: '/onboarding/documents-being-reviewed',
  },
  // {
  //   path: '/onboarding/verification-questions',
  // },
  {
    path: '/onboarding/account-suspended',
  },
  {
    path: '/onboarding/try-upload-again',
  },
  {
    path: '/onboarding/documents-required',
  },
  {
    path: '/onboarding/information-not-verified',
  },
  // {
  //   path: '/onboarding/information-not-verified-kba',
  // },
  {
    path: '/onboarding/upload-document',
  },
  {
    path: '/onboarding/connect-funding-source',
  },
  {
    path: '/onboarding/connect-payroll',
  },
  {
    path: '/onboarding/connect-bank-account',
  },
  {
    path: '/onboarding/payroll-disclaimer',
  },
  {
    path: '/onboarding/payroll-connected',
  },
  // {
  //   path: '/everywhere-card/learn',
  // },
  // {
  //   path: '/everywhere-card',
  // },
]

export const useAutomation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const pageCt = useRef(0)
  const elCt = useRef(0)
  const keysPressed = useRef([])
  const [currentSelector, setCurrentSelector] = useState('')
  const [cb, setCb] = useState(() => {})
  const automationLegend = useSelector(({ app }) => app.automationLegend)
  const autoInput = useSelector(({ app }) => app.autoInput)
  const data = useSelector(({ global }) => global[currentSelector])
  const { 
    closeModal, 
    closePopover,
    openAutomationLegend,
    closeAutomationLegend,
    toggleAutoInput,
  } = useAction()

  useEffect(() => {
    if (data) {
      cb(data, navigate)
      setCurrentSelector('')
      setCb(() => {})
      pageCt.current++
      elCt.current = 0
    }
  }, [data])

  useEventListener('keyup', e => {
    keysPressed.current.push(e.keyCode)
    if (keysPressed.current.toString().includes('38,38,40,40,37,39,37,39,66,65,16')) { // Konami
      if (!PAGES[pageCt.current]) { // start over
        pageCt.current = 0
        elCt.current = 0
      }
      if (pageCt.current === 0) {
        openAutomationLegend() // open legend
        if (!autoInput) toggleAutoInput() // autofill inputs
      }
      if (pageCt.current === 0 && PAGES[pageCt.current].path !== location.pathname) { // starting page
        navigate(PAGES[pageCt.current].path)
      } else {
        const isLeft = e.keyCode === 37
        const isRight = e.keyCode === 39
        const isSlash = e.keyCode === 191
        const isPeriod = e.keyCode === 190
        const isFillInput = e.keyCode === 186
        const shiftKey = e.shiftKey
        if (isFillInput) toggleAutoInput()
        // if (isFillInput) {
        //   // document.querySelectorAll('input').forEach(el => {
        //   //   el.value = random(1000).toString()
        //   // })
        //   // document.querySelectorAll('.date-picker').forEach(el => {
        //   //   el.click()
        //   //   setTimeout(() => {
        //   //     document.querySelectorAll('button[title="Next month"]')[1].click()
        //   //     document.querySelectorAll('.MuiDateRangePickerDay-day')[7].click()
        //   //     el.blur()
        //   //     // setTimeout(() => {
        //   //     // }, 200)
        //   //   }, 200)
        //   // })
        // }
        if (isSlash) { // close elements
          closeModal()
          closePopover()
          // document.body.click()
        }
        if (isPeriod) { // toggle legend
          automationLegend ? closeAutomationLegend() : openAutomationLegend()
        }
        if (isLeft) { // go back
          elCt.current = 0
          pageCt.current = Math.max(0, pageCt.current - 1)
          navigate(PAGES[pageCt.current].path)
        } else if (isRight) { // go forwards
          const nextEl = PAGES[pageCt.current].interactions?.[elCt.current]
          if (nextEl && !shiftKey) { // find next interaction
            const el = document.querySelector(nextEl)
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
              el.click()
              console.warn('Interaction: ', nextEl)
            } else {
              console.warn('Interaction Skip: ', nextEl)
            }
            elCt.current++
          } else if (PAGES[pageCt.current + 1].preload) { // dynamic route
            const preload = PAGES[++pageCt.current].preload
            dispatch({
              type: preload.type,
            })
            setCurrentSelector(preload.selector)
            setCb(() => preload.cb)
          } else { // go to next page
            elCt.current = 0
            navigate(PAGES[++pageCt.current].path)
          }
        }
      }
    }
  })
}